export const initializePendo = (pendoApiKey: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    (function initialize(apiKey) {
      (function initializePendoScript(p, e, n, d) {
        let w, x;

        const o = (p[d] = p[d] || {});

        // eslint-disable-next-line no-underscore-dangle
        o._q = o._q || [];
        const v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track'];

        for (w = 0, x = v.length; w < x; ++w) {
          (function initializeFunction(m) {
            o[m] =
              o[m] ||
              function pendoFunction() {
                // eslint-disable-next-line no-underscore-dangle, prefer-rest-params
                o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
              };
          })(v[w]);
        }
        const y = e.createElement(n) as HTMLScriptElement;

        y.async = true;
        y.src = 'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
        const z = e.getElementsByTagName(n)[0];

        if (z?.parentNode) {
          z.parentNode.insertBefore(y, z);
          y.onload = () => resolve();
          y.onerror = () => reject(new Error('Failed to load Pendo script'));
        } else {
          reject(new Error('Failed to insert Pendo script'));
        }
      })(window, document, 'script', 'pendo');
    })(pendoApiKey);
  });
};

export const setupPendoForUser = (user: PendoUser) => {
  if (window.pendo) {
    window.pendo.initialize(user);
  }
};

export const indentifyPendoUser = (user: PendoUser) => {
  if (window.pendo) {
    window.pendo.identify(user);
  }
};

export const clearSession = () => {
  if (window.pendo) {
    window.pendo.clearSession();
  }
};

export const formatPendoUser = (user: User) => {
  return {
    visitor: {
      id: user.uuid,
      email: user.email,
      createdAt: user.createdAt,
      role: user.roles[0],
    },
    account: {
      id: user.accountId,
      type: user.accountType,
      name: user.accountName,
      createdAt: user.accountCreatedAt,
    },
  };
};
